import { render, staticRenderFns } from "./BaseTransactionDetailsFutureCashback.vue?vue&type=template&id=5aba2415&"
import script from "./BaseTransactionDetailsFutureCashback.vue?vue&type=script&lang=js&"
export * from "./BaseTransactionDetailsFutureCashback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports